/** @jsxImportSource @emotion/react */
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import App from './App'
import { store } from './app/store'
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
// import 'bootstrap/dist/css/bootstrap.css';
import './styles/font-awesome/css/font-awesome.min.css';
import './index.css'
import './styles/blueUplan.css'
import './styles/quote.css'
import './styles/planner.css'
import jquery from 'jquery';

const container = document.getElementById('root')

declare global {
  interface Window {
    jQuery: typeof jQuery;
    $: typeof jQuery;
  }
}
window.$ = window.jQuery=jquery;

require('bootstrap/dist/js/bootstrap.min');
require('bootstrap-touchspin/dist/jquery.bootstrap-touchspin.min.js');

if (container) {
  const root = createRoot(container)

  root.render(
      <Provider store={store}>
        <App />
      </Provider>,
  )
} else {
  throw new Error(
      "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}